// extracted by mini-css-extract-plugin
module.exports = {"overlay":"fd","bodyOpen":"gd","content":"hd","header":"id","close":"jd","closeNoHeading":"kd"};